import { ReactNode } from 'react';
import cn from 'classnames';
import styles from './filterHeader.scss';

export interface FilterHeaderProps {
  className?: string;
  displayName: string;
  onClick?: () => void;
  border?: boolean;
  children?: ReactNode;
}
export const FilterHeader = ({
  className,
  displayName,
  onClick,
  border,
  children
}: FilterHeaderProps) => (
  <div
    onClick={onClick}
    className={cn(className, styles.filterHeader, { [styles.border]: border })}
  >
    <span className={styles.name}>{displayName}</span>
    {children && <div className={styles.value}>{children}</div>}
  </div>
);
